import { NgModule, ErrorHandler } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
// import { BrowserAnimationsModule } from '@angular/platform-browser/animations'; // necessário para angular calendar
import { HttpClientModule, HttpClient } from '@angular/common/http'; 
import { RouteReuseStrategy } from '@angular/router';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { ScreenOrientation } from '@ionic-native/screen-orientation/ngx';
import { Network } from '@ionic-native/network/ngx';
// import { Dialogs } from '@ionic-native/dialogs/ngx';
import { Device } from '@ionic-native/device/ngx';
import { NativePageTransitions } from '@ionic-native/native-page-transitions/ngx';

// Compartilhamento de arquivo e geração de pdfs
import { SocialSharing } from '@ionic-native/social-sharing/ngx';

import { File } from '@ionic-native/file/ngx';
import { FileOpener } from '@ionic-native/file-opener/ngx';
// import { FileTransfer } from '@ionic-native/file-transfer/ngx';


// Porque optei por Ionic Storage e não cordova Native Storage https://stackoverflow.com/questions/51377622/difference-between-ionic-storage-and-native-storage
import { IonicStorageModule } from '@ionic/storage';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';


// Implmenetando tradução
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { ModalLanguagePageModule } from 'src/app/components/modal-language/modal-language.module'; 
import { ModalPageModule } from 'src/app/components/modal/modal.module';

import { InAppPurchase2 } from '@ionic-native/in-app-purchase-2/ngx';

import { OneSignal } from '@ionic-native/onesignal/ngx';
// Apenas FCOL
// import { TestPageModule } from 'src/app/pages/fertilityCheck/test/test.module';
// import { MenstruationsPageModule } from 'src/app/pages/menstruations/menstruations.module';


/*
  Definiter o caminho dos arquivos de tradução
*/
export const translateLanguageLoader = function (http: HttpClient) {
  return new TranslateHttpLoader(http, `./assets/data/${environment.appName}/i18n/`, '.json');
}
 

@NgModule({
  declarations: [AppComponent], 
  entryComponents: [],
  imports: [
    BrowserModule,
    // BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    IonicModule.forRoot({animated: true}),
    IonicStorageModule.forRoot({
      name: environment.localDbName,
      driverOrder: ['sqlite', 'indexeddb', 'websql', 'localstorage'], // possiveis  ['sqlite', 'indexeddb', 'websql', 'localstorage']
    }),
    ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production }), 
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: (translateLanguageLoader),
        deps: [HttpClient]
      }
    }),
    ModalLanguagePageModule,
    ModalPageModule,
    // TestPageModule,
    // MenstruationsPageModule
    
  ],
  providers: [
    StatusBar,
    SplashScreen,
    ScreenOrientation,
    Network,
    // Dialogs,
    Device,
    NativePageTransitions,
    SocialSharing,
    File,
    FileOpener,
    // FileTransfer,
    InAppPurchase2,
    OneSignal,
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
  ],
  bootstrap: [AppComponent]
})
export class AppModule {} 